// GoldKaratCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import {
  SecondAds,
  FirstAds,
  MobileUnderCalAds,
} from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Hitung nilai emas dengan mudah dan akurat - Kalkulator Konversi Karat Emas";
const DESCRIPTION =
  "Kalkulator ini menghitung berat emas dalam berbagai karat berdasarkan berat asli emas dan karat yang ditentukan";
const KEYWORDS = "konversi karat emas, karat ";
const OG_URL = "https://do-calculate.com/calculator/id/gold-karat/";
function GoldKaratCalculator() {
  const [goldWeight, setGoldWeight] = useState(1.0);
  const [goldKarat, setGoldKarat] = useState(24);
  const [conversionResults, setConversionResults] = useState(null);
  const [error, setError] = useState(null);
  const handleGoldWeightChange = (event) => {
    setGoldWeight(event.target.value);
  };
  const handleGoldKaratChange = (event) => {
    setGoldKarat(event.target.value);
  };
  const calculateGoldKarat = () => {
    // Validate inputs
    const weight = parseFloat(goldWeight);
    const karat = parseFloat(goldKarat);
    if (isNaN(weight) || weight <= 0) {
      setError("Harap masukkan berat yang valid lebih besar dari nol");
      setConversionResults(null);
      return;
    }
    if (isNaN(karat) || karat <= 0 || karat > 24) {
      setError("Harap masukkan karat yang valid antara 1 dan 24");
      setConversionResults(null);
      return;
    }
    try {
      // Calculate pure gold weight from original karat
      const pureGoldWeight = weight * (karat / 24);
      // Convert to each target karat
      const results = {};
      const targetKarats = [24, 22, 21, 18, 14, 10];
      targetKarats.forEach(targetKarat => {
        // Formula: convertedWeight = pureGoldWeight / (targetKarat / 24)
        // Which simplifies to: pureGoldWeight * (24 / targetKarat)
        const convertedWeight = pureGoldWeight * (24 / targetKarat);
        results[`karat_${targetKarat}`] = convertedWeight.toFixed(4);
      });
      setConversionResults(results);
      setError(null);
    } catch (err) {
      console.error(err);
      setError("Terjadi kesalahan tak terduga. Silakan coba lagi.");
      setConversionResults(null);
    }
  };
  return (
    <div >
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <b> Kalkulator Konversi Karat Emas ke Berbagai Karat </b>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                Kalkulator ini menghitung berat emas dalam berbagai karat berdasarkan berat asli emas dan karat yang ditentukan <br />
                Kalkulator ini bertujuan untuk mengonversi berat emas dari satu karat ke berbagai karat yang berbeda
                <br />
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col calculatorStyle" style={{ minWidth: "300px" }}>
                <div className="p-3 mb-2 bg-success text-white">
                  Kalkulator Konversi Karat Emas ke Berbagai Karat
                </div>
                <hr />
                <br />
                <div className="form-group d-flex align-items-center">
                  <label htmlFor="goldWeight" className="form-label ms-2">
                    Berat asli emas:
                  </label>
                  <input
                    type="number"
                    id="goldWeight"
                    value={goldWeight}
                    onChange={handleGoldWeightChange}
                    className="form-control"
                    style={{ width: "100%", marginLeft: "10px" }}
                    placeholder="Contoh: 27.7"
                    step="0.01"
                    min="0"
                  />
                  <label htmlFor="goldKarat" className="form-label ms-2">
                    Karat emas asli:
                  </label>
                  <select
                    id="goldKarat"
                    style={{ width: "90%" }}
                    className="form-select"
                    value={goldKarat}
                    onChange={handleGoldKaratChange}
                  >
                    <option value="24">24</option>
                    <option value="22">22</option>
                    <option value="21">21</option>
                    <option value="18">18</option>
                    <option value="14">14</option>
                    <option value="10">10</option>
                  </select>
                </div>
                <br />
                <hr />
                <button
                  className="btn btn-success"
                  style={{ fontSize: "20px" }}
                  onClick={calculateGoldKarat}
                >
                  Hitung
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-auto">
                <br />
                {error && (
                  <div className="alert alert-danger">
                    <b>
                      <u> Terjadi kesalahan :</u>
                    </b>{" "}
                    {error}{" "}
                  </div>
                )}
                {conversionResults && (
                  <div className="mt-4 p-3 alert alert-success">
                    <h3>Hasil:</h3>
                    <p>
                      Jika Anda memiliki <b>{goldWeight}</b> gram emas dengan karat{" "}
                      <b>{goldKarat}</b>, maka nilai emas ini setara dengan:
                    </p>
                    <ul className="list-group">
                      {Object.entries(conversionResults).map(
                        ([karatKey, weight]) => (
                          <li key={karatKey} className="list-group-item">
                            {parseFloat(weight).toFixed(2)} gram emas dengan karat{" "}
                            {karatKey.replace("karat_", "")}
                          </li>
                        )
                      )}
                    </ul>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                Deskripsi Kalkulator Konversi Karat Emas ke Berbagai Karat :
              </div>
              <div className="info-section-body">
                <u>
                  <b> Konversi Karat Emas ke Berbagai Karat: </b>{" "}
                </u>{" "}
                <br/>                Kalkulator ini mengonversi berat emas dari satu karat ke berbagai karat yang berbeda. Kalkulator menerima berat emas dan karat asli sebagai input. Kalkulator memvalidasi input yang diterima, di mana berat dan karat harus lebih besar dari nol dan karat asli tidak boleh melebihi 24 karat (emas murni).
                <br />
                Berdasarkan berat dan karat asli, kalkulator menghitung berat setara emas untuk setiap karat yang didukung (24, 22, 21, 18, 14, 10). Kandungan emas murni dihitung terlebih dahulu, kemudian dikonversi ke berbagai karat.
                <br/>                Di akhir perhitungan, berat yang dihitung untuk setiap karat ditampilkan dengan akurasi tinggi.
                <br/>                Kalkulator ini memudahkan proses konversi berat emas antara berbagai karat dengan mudah dan akurat, bahkan jika Anda tidak memiliki pengetahuan khusus di bidang ini.
                <br />
                <hr />
                <div className="alert alert-info">
                  <b>Contoh ilustrasi:</b>
                  <br />
                  Jika Anda memiliki 27.7 gram emas dengan karat 22:
                  <ul>
                    <li>Kandungan emas murni = 27.7 × (22/24) = 25.39 gram</li>
                    <li>Konversi ke karat 24 = 25.39 gram (lebih ringan dari berat asli)</li>
                    <li>Konversi ke karat 18 = 25.39 × (24/18) = 33.85 gram (lebih berat dari berat asli)</li>
                  </ul>
                  <b>Aturan penting:</b> Saat mengonversi ke karat yang lebih tinggi, berat berkurang. Saat mengonversi ke karat yang lebih rendah, berat bertambah.
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default GoldKaratCalculator;